import { Menu, Search } from 'lucide-react';
import { IconButton, UserAvatar } from '@kainos/ui';
import { NotificationBell, useUnreadCount } from '@/features/notifications';
import { useCurrentUser } from '@/lib/auth';
import { useCurrentPageTitle } from '@/store/page-title';
import { useUi } from '@/store/ui-store';

/** 64px header: screen title on the left, quick actions and the user on the right. */
export function Topbar() {
  const title = useCurrentPageTitle();
  const user = useCurrentUser();
  const unreadCount = useUnreadCount();
  const { toggleMobileNav } = useUi();

  return (
    <header className="sticky top-0 z-20 flex h-16 shrink-0 items-center justify-between border-b border-line bg-surface px-5 lg:px-8">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={toggleMobileNav}
          aria-label="Abrir navegación"
          className="-ml-1 flex h-9 w-9 items-center justify-center rounded-lg text-ink-muted hover:bg-line-subtle lg:hidden"
        >
          <Menu size={19} />
        </button>
        <h1 className="truncate text-[15px] font-bold text-ink">{title}</h1>
      </div>

      <div className="flex items-center gap-3.5">
        <IconButton label="Buscar">
          <Search size={16} strokeWidth={1.8} />
        </IconButton>

        <NotificationBell unreadCount={unreadCount} />

        {user ? <UserAvatar name={user.fullName} size={32} /> : null}
      </div>
    </header>
  );
}
